import React from 'react'
import { formatDate } from '../../../utils/formatDate';

const BookingCard = (props) => {
  const {
    eventName,
    eventDate,
    venue,
    eventCategory,
    imageUrl,
    totalAmount,
  } = props;
  return (
    <div className='p-4 md:p-8 flex flex-col  gap-10 border-grey-5 rounded-xl shadow-sm'>
      <div className='flex flex-row justify-between gap-6'>
        <div className='flex flex-col gap-2 items-start justify-start text-left '>
          <div className='heading-16'>{eventName}</div>
          <div className='label-14 text-grey-70'>{formatDate(eventDate)}</div>
          <div className='label-14 text-grey-70'> {venue}</div>
          <div className='text-primary label-12 bg-light rounded-2xl py-1 px-3'>{eventCategory}</div>
        </div>
        <img src={imageUrl}
          alt='eventImg' 
          className='w-[127px] md:w-[180px] h-[72px] md:h-[100px] rounded-lg object-cover'/>
      </div>
      <div className='flex justify-between label-14 '>
        <div>Total Amount</div>
        <div className='heading-16'>₹ {totalAmount}</div>
      </div>
    </div>
  )
}

export default BookingCard